import React, { Component } from 'react';
import { Icon, Row, Col } from 'antd';
import { graphql, compose } from 'react-apollo';
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import { invalidateToken } from '../../authorization/mutations/invalidateToken';
import ProfileFields from './fields';
import ProfileForm from './form';
import './profile.css';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = { editing: false };
  }

  renderProfileForm() {
    const switchToView = () => this.setState({ editing: false });

    return (
      <ProfileForm onSubmit={switchToView} onCancel={switchToView}/>
    )
  }

  renderEditButton() {
    return (
      <a onClick={() => this.setState({editing: true})}>
        Edit
        <Icon type="edit" className="profile-page__edit-icon" />
      </a>
    )
  }

  render() {
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Row style={{height: 40}}>
            <Col span={12}>
              <h2 style={{marginBottom: 10}}>My Profile</h2>
            </Col>
            <Col style={{float: 'right'}}>
              { !this.state.editing && this.renderEditButton() }
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              { this.state.editing ? this.renderProfileForm() : <ProfileFields/> }
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default compose(
  graphql(getCurrentUser),
  graphql(invalidateToken)
)(Profile);



// WEBPACK FOOTER //
// ./src/components/pages/profile/profile.js